export const DB_NAME = "LocalErgonaDB";
export const DB_VERSION = 1;
export const LOCAL_ASSESSMENTS_OBJECT_STORE = "localAssessments";
